import(/* webpackMode: "eager", webpackExports: ["CompetitionPicker"] */ "/app/apps/web/app/dashboard/_sections/CompetitionPicker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardBand"] */ "/app/apps/web/app/dashboard/_sections/DashboardBand.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Leaderboard"] */ "/app/apps/web/app/dashboard/_sections/Leaderboard.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ContourCanvas"] */ "/app/packages/ui/src/ContourCanvas.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/NavDrawer.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/NavMenu.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/ThemeSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useReducedMotion"] */ "/app/packages/ui/src/useReducedMotion.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useTheme"] */ "/app/packages/ui/src/useTheme.ts");
